import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded = ["direction", "color", "dividerStyle", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useDivider = function useDivider(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'base.subtle' : _ref$color,
    _ref$dividerStyle = _ref.dividerStyle,
    dividerStyle = _ref$dividerStyle === void 0 ? 'solid' : _ref$dividerStyle,
    ref = _ref.ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return {
    dividerProps: _objectSpread(_objectSpread({
      role: 'separator',
      'aria-orientation': direction,
      borderStyle: dividerStyle,
      borderColor: color,
      ref: ref
    }, direction === 'vertical' ? {
      borderWidth: ['0', '1'],
      width: '0',
      height: '100%'
    } : {
      borderWidth: ['1'],
      width: '100%',
      height: '0'
    }), rest)
  };
};

export { useDivider };
//# sourceMappingURL=useDivider.js.map
